import { Fragment } from 'react'
import {t} from 'i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Container, Row, Col, Button } from 'reactstrap'

import Breadcrumbs from '../../layout/breadcrumb/Breadcrumb';
import { isNull } from '../../izUtils'
import AddUpdateFacility from '../../components/facilities/AddUpdateFacility';
import LinkedSystemComponent from '../../components/facilities/linkedSystems/LinkedSystemComponent';
import DictionaryInfoButton from '../../components/dictionary/DictionaryInfoButton';

const Facilities = () => {
    const Navigate = useNavigate();
    const { clientId, facilityId } = useParams();

    return (
        <Fragment>
            <Breadcrumbs parent={t('breadcrumb.clients')} title={t('breadcrumb.facilities')} />
            <Container fluid={true}>
                <Row>
                    <Col md="12">
                        {!isNull(facilityId) && <AddUpdateFacility />}
                    </Col>
                    {facilityId !== 'create' && <LinkedSystemComponent />}
                </Row>
                <hr/>
                <div className='mb-4'>
                    <div className='d-flex align-items-center mt-2'>
                        <Button color="danger" className="me-2" onClick={() => Navigate('/clients/' + clientId)}>{t('back')}</Button>
                        <DictionaryInfoButton code="client_facilities.form.back" id="client_facilities.form.back" />
                    </div>
                </div>
            </Container>
        </Fragment>
    )
}

export default Facilities